<template>
    <span>
        {{min}}
       <span v-if="min != max">
           - {{max}}
       </span>
    </span>
</template>

<script>
export default {
  name: 'MinMaxDisplay',
  props: {
    min: Number,
    max: Number
  }
}
</script>

<style scoped lang="sass">

</style>
